export default __webpack_public_path__ + "static/media/Honorarios_planilla_consultas_y_practicas.310a81ca.xlsx";